import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

const RedCalendarCrossIcon = () => (
  <SvgIcon>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="4" fill="#FDECEC" />
      <path
        d="M17.25 6H16.5V4.5H15V6H9V4.5H7.5V6H6.75C5.925 6 5.25 6.675 5.25 7.5V18C5.25 18.825 5.925 19.5 6.75 19.5H17.25C18.075 19.5 18.75 18.825 18.75 18V7.5C18.75 6.675 18.075 6 17.25 6ZM17.25 18H6.75V10.5H17.25V18ZM6.75 9V7.5H17.25V9H6.75ZM9.1725 16.0575L9.9675 16.8525L11.7975 15.0225L13.6275 16.8525L14.4225 16.0575L12.5925 14.2275L14.4225 12.3975L13.6275 11.6025L11.7975 13.4325L9.9675 11.6025L9.1725 12.3975L11.0025 14.2275L9.1725 16.0575Z"
        fill="#CC3226"
      />
    </svg>
  </SvgIcon>
);

export default RedCalendarCrossIcon;
